export class AppConst {
    static IntNull = -999999;
    static DateNull = new Date(1900, 1, 1);
    static DateMax = new Date(9999, 12, 31);
}
